import React, { useEffect, useState } from 'react';
import { exchangeNumistaToken } from '../services/api';

const NumistaCallback = () => {
    
    // Adapted for non-React-Router environment
    
    const [status, setStatus] = useState('processing');
    const [error, setError] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const errorParam = params.get('error');

        if (errorParam) {
            setStatus('error');
            setError(errorParam);
            return;
        }

        if (code) {
            exchangeToken(code, state);
        } else {
            console.error(window.location.href);
            // If we are just mounting, check if we have query params. If not, maybe we shouldn't be here.
            // But App.js controls that.
        }
    }, []);

    const exchangeToken = async (code, state) => {
        try {
            await exchangeNumistaToken(code, state);
            setStatus('success');
            setTimeout(() => {
                // Clear query params and go home
                window.location.href = '/'; 
            }, 2000);
        } catch (err) {
            console.error(err);
            setStatus('error');
            setError(err.response?.data?.error || err.message);
        }
    };

    return (
        <div style={{ padding: '40px', textAlign: 'center' }}>
            <h2>Numista Authentication</h2>
            {status === 'processing' && <p>Connecting...</p>}
            {status === 'success' && (
                <div style={{ color: 'green' }}>
                    <p>Successfully connected! Redirecting...</p>
                </div>
            )}
            {status === 'error' && (
                <div style={{ color: 'red' }}>
                    <p>Connection failed: {error}</p>
                    <a href="/">Return to Home</a>
                </div>
            )}
        </div>
    );
};

export default NumistaCallback;
